import { Col, Empty, Flex, Modal, Row, Tabs, Typography, theme } from "antd";
import { useEffect, useState, useContext } from "react";
import DeviceFilter from "../../components/device/DeviceFilter";
import DeviceCard from "../../components/device/DeviceCard";
import DeviceInformation from "../../components/device/DeviceInformation";
import useFetch from "../../hooks/useFetch";
import { IndexContext } from "../../context/IndexContext";
import { DATA_REFRESH_RATE } from "../../configs/configs";
import dayjs from "dayjs";

const { Text, Title } = Typography;
const { useToken } = theme;

function MonitoringPage() {
  const { token } = useToken();
  const [openModal, setOpenModal] = useState(false);
  const [deviceID, setDeviceID] = useState(null);
  const [modalData, setModalData] = useState({ title: "-" });

  const { messageApi, siteSelected } = useContext(IndexContext);
  const [fetchWrapper] = useFetch();

  const [loading, setLoading] = useState(false);

  const [devices, setDevices] = useState(null);
  const [activeKey, setActiveKey] = useState(1);
  const [filterValues, setFilterValues] = useState();

  // site commissioning date
  const [siteCommissioningDate, setSiteCommissioningDate] = useState(dayjs());

  /* API to get site commissioning date */
  function getSiteCommissioningDate() {
    fetchWrapper({
      endpoint_url: "trending/getSiteCommissioningDate",
      body: {
        site_id: siteSelected,
      },
      onSuccess: (fetch_output) => {
        if (fetch_output.status === true) {
          setSiteCommissioningDate(fetch_output.site_commissioning_date);
        }
      },
    });
  }

  /* API to get device details */
  function getDeviceCardInfo() {
    setLoading(true);
    fetchWrapper({
      endpoint_url: "device_monitoring/getDeviceCardInfo",
      body: {
        site_id: siteSelected,
        device_type: filterValues
          ? filterValues.types && filterValues.types?.length > 0
            ? filterValues.types
            : []
          : [],
        area: filterValues
          ? filterValues.areas && filterValues.areas?.length > 0
            ? filterValues.areas
            : []
          : [],
        seu: filterValues
          ? filterValues.seus && filterValues.seus?.length > 0
            ? filterValues.seus
            : []
          : [],
        alarm_status: filterValues
          ? filterValues.status && filterValues.status?.length > 0
            ? filterValues.status
            : []
          : [],
        name: filterValues
          ? filterValues.name && filterValues.name?.length > 0
            ? filterValues.name
            : ""
          : "",
      },
      onSuccess: (fetch_output) => {
        if (fetch_output.status === true) {
          setDevices(fetch_output.device_details);
        }
        setLoading(false);
      },
    });
  }

  useEffect(() => {
    if (siteSelected) {
      getDeviceCardInfo();
      getSiteCommissioningDate();

      // refresh data every configurable second
      const timer = setInterval(() => {
        getDeviceCardInfo();
      }, DATA_REFRESH_RATE * 1000);

      return () => {
        clearInterval(timer);
      };
    }
  }, [siteSelected, filterValues]);

  // open modal after modalData is set
  useEffect(() => {
    if (modalData.title !== "-") {
      setOpenModal(true);
    }
  }, [modalData]);

  return (
    <>
      <Row gutter={[12, 12]}>
        <Col span={24}>
          <DeviceFilter
            themeToken={token}
            activeKey={activeKey}
            setActiveKey={setActiveKey}
            filterValues={filterValues}
            setFilterValues={setFilterValues}
          />
        </Col>
        <Col span={24}>
          <Text strong>DEVICES</Text>
        </Col>
        <Col span={24}>
          <Row gutter={[18, 18]}>
            {devices?.map((device, index) => {
              const key = `col-${index}`;
              return (
                <Col
                  key={device.ID}
                  xs={24}
                  sm={24}
                  md={12}
                  lg={8}
                  xl={6}
                  xxl={6}
                >
                  <DeviceCard
                    device={device}
                    themeToken={token}
                    setOpenModal={() => {
                      setDeviceID(device.ID);
                      setModalData({
                        deviceID: device.ID,
                        imagePath: device.ImagePath,
                        title: device.name,
                        area: device.area,
                        seu: device.seu,
                        deviceType: device.deviceType,
                        deviceModel: device.deviceModel,
                      });
                    }}
                  />
                </Col>
              );
            })}
          </Row>
          {devices?.length == 0 && <Empty className="mt-5"></Empty>}
        </Col>
      </Row>
      <DeviceInformation
        setOpenModal={setOpenModal}
        deviceID={deviceID}
        modalData={modalData}
        openModal={openModal}
        themeToken={token}
        siteCommissioningDate={siteCommissioningDate}
      />
    </>
  );
}

export default MonitoringPage;
